<template>
    <div class="component-third-auth-buttons">
        <button class="button button-vk" @click="handleVKIDButton" :disabled="disableVkButton" type="button" title="Войти через VK ID">
            <img src="/img/svg/icon-vk.svg" alt="" width="22" height="22" loading="lazy">
        </button>
        <button class="button button-alfa" @click="handleAlfaButton" :disabled="disableAlfaButton" type="button" title="Войти по Alfa ID">
            <img src="/img/svg/icon-alfa.svg" alt="" width="24" height="24" loading="lazy">
        </button>
        <button class="button button-yandex" @click="handleYandexButton" :disabled="disableYandexButton" type="button" title="Войти с Яндекс ID">
            <img src="/img/svg/icon-ya.svg" alt="" width="24" height="24" loading="lazy">
        </button>
        <button class="button button-tinkoff" @click="handleTinkoffButton" :disabled="disableTinkoffButton" type="button" title="Войти с TBank ID">
            <img src="/img/svg/icon-tinkoff.svg" alt="" width="24" height="24" loading="lazy">
        </button>
        <button class="button button-gazprom" @click="handleGazpromButton" :disabled="disableGazpromButton" type="button" title="Войти с Газпром ID">
            <img src="/img/svg/icon-gazprom.svg" alt="" width="48" height="48" loading="lazy">
        </button>
    </div>
</template>

<script>
import { api } from "../js/api";
import registrationHelper from '../js/utils/registrationHelper';

export default {
    name: 'ThirdAuthButtons',

    mixins: [
        registrationHelper
    ],

    data() {
        return {
            disableVkButton: false,
            disableAlfaButton: false,
            disableYandexButton: false,
            disableTinkoffButton: false,
            disableGazpromButton: false
        };
    },

    props: {
        preClickEvent: {
            type: Function,
            default: () => undefined
        }
    },

    computed: {
        redirectVKUri() {
            return process.env.API_URL + '/vk/auth';
        },

        redirectAlfaUri() {
            return process.env.API_URL + '/alfaid/auth';
        }
    },

    methods: {
        handleVKIDButton() {
            this.preClickEvent();

            this.disableVkButton = true;

            api.get('/vk/generateUuid')
                .then((response) => {
                    if (response.data.data) {
                        const uuid = response.data.data;
                        const body = Object.assign(this.getDefaultRegistrationParams(), {
                            apptoken: process.env.TOKEN,
                        });

                        const state = window.btoa(JSON.stringify(body)).replace(/\+/g, "-").replace(/=/g, "").replace(/\//g, "_");
                        const query = `redirect_state=${state}&uuid=${uuid}&app_id=${process.env.VK_APP_ID}&response_type=silent_token&redirect_uri=${this.redirectVKUri}`;
                        location.assign(`https://id.vk.com/auth?${query}`);
                    }
                }).catch((error) => {
                console.log('generate vk uuid error: ', error);
                this.disableVkButton = false;
            });

            document.dispatchEvent(new CustomEvent('pushGoal', { detail: { 'goal': 'vk_auth_button' } }));
        },

        handleAlfaButton() {
            this.preClickEvent();

            this.disableAlfaButton = true;

            const body = Object.assign(this.getDefaultRegistrationParams(), {
                apptoken: process.env.TOKEN,
            });

            api.post('/alfaid/generateUuid', body)
                .then((response) => {
                    if (response.data.data) {
                        const uuid = response.data.data;

                        location.assign(`https://id.alfabank.ru/oidc/authorize?response_type=code&client_id=${process.env.ALFA_APP_ID}&redirect_uri=${this.redirectAlfaUri}&scope=openid%20profile%20email%20phone&state=${uuid}`);
                    }
                })
                .catch ((error) => {
                    console.log('generate alfa uuid error: ', error);
                    this.disableAlfaButton = false;
                });

            document.dispatchEvent(new CustomEvent('pushGoal', { detail: { 'goal': 'alfa_auth_button' } }));
        },

        handleYandexButton() {
            this.preClickEvent();

            this.disableYandexButton = true;

            const body = Object.assign(this.getDefaultRegistrationParams(), {
                apptoken: process.env.TOKEN,
            });

            const state = window.btoa(JSON.stringify(body)).replace(/\+/g, "-").replace(/=/g, "").replace(/\//g, "_");

            api.get('/yaid/authLink', { params: {
                    state: state,
                    auth: true
                }})
                .then((response) => {
                    location.assign(response.data);
                })
                .catch((error) => {
                    console.log('generate ya id link error: ', error);
                    this.disableYandexButton = false;
                });

            document.dispatchEvent(new CustomEvent('pushGoal', { detail: { 'goal': 'yandex_auth_button' } }));
        },

        handleTinkoffButton() {
            this.preClickEvent();

            this.disableTinkoffButton = true;

            const body = Object.assign(this.getDefaultRegistrationParams(), {
                apptoken: process.env.TOKEN,
            });

            const state = window.btoa(JSON.stringify(body)).replace(/\+/g, "-").replace(/=/g, "").replace(/\//g, "_");

            api.get('/tinkoffid/authLink', {
                params: {
                    state: state,
                    auth: true
                }
            })
                .then((response) => {
                    location.assign(response.data);
                })
                .catch((error) => {
                    console.log('generate tinkoff id link error: ', error);
                    this.disableTinkoffButton = false;
                });

            document.dispatchEvent(new CustomEvent('pushGoal', { detail: { 'goal': 'tinkoff_auth_button' } }));
        },

        handleGazpromButton() {
            this.preClickEvent();

            this.disableGazpromButton = true;

            const body = Object.assign(this.getDefaultRegistrationParams(), {
                apptoken: process.env.TOKEN
            });

            api.post('/gid/authLink', body)
                .then((response) => {
                    location.assign(response.data);
                })
                .catch((error) => {
                    console.log('generate gazprom id link error: ', error);
                    this.disableGazpromButton = false;
                });

            document.dispatchEvent(new CustomEvent('pushGoal', { detail: { 'goal': 'gazprom_auth_button' } }));
        }
    }
};
</script>